// «+ Запись» of a section whose type has required fields besides the title (stage J7: a material's link, a stream's address, a slot's
// time): the fields are asked first, so the record is made whole instead of being refused by the server and vanishing.

import { useState } from 'react';
import type { FieldDef, Id } from '@confdeck/core-shared';
import { useMeta } from '../sync/react.tsx';
import { Button, Dialog, Input, Field } from '../ui/primitives.tsx';
import { DateInput } from '../ui/DateInput.tsx';
import s from './record.module.css';

/** The required fields a person types in: plain values (text, link, email, number, date, time) of the type, not managed ones. */
export function askedFields(meta: ReturnType<typeof useMeta>, typeId: Id): FieldDef[] {
  const type = meta.type(typeId);
  return meta.fields(typeId).filter((f) => f.required && !f.archivedAt && !f.options.managed && f.key !== type?.titleField
    && ['text', 'url', 'email', 'phone', 'number', 'money', 'date'].includes(f.fieldType));
}

export function NewRecordDialog({ typeId, fields, onCreate, onClose }: { typeId: Id; fields: FieldDef[]; onCreate: (data: Record<string, unknown>) => void; onClose: () => void }) {
  const meta = useMeta();
  const type = meta.type(typeId);
  const [values, setValues] = useState<Record<string, string>>({});
  const [title, setTitle] = useState('');
  const missing = fields.find((f) => !String(values[f.key] ?? '').trim());
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (missing) return;
    const data: Record<string, unknown> = {};
    for (const f of fields) {
      const v = values[f.key]!.trim();
      data[f.key] = f.fieldType === 'number' ? Number(v) : f.fieldType === 'money' ? Math.round(Number(v.replace(',', '.')) * 100) : v;
    }
    onCreate({ ...(title.trim() && type ? { [type.titleField]: title.trim() } : {}), ...data });
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()} label={`Новая запись: ${type?.name ?? ''}`}>
      <form className={s.dialog} onSubmit={submit}>
        <h2 className={s.dialogTitle}>{type?.name ?? 'Запись'}</h2>
        <Field label={<>{meta.field(typeId, type?.titleField ?? '')?.name ?? 'Название'}</>}><Input autoFocus value={title} onChange={(e) => setTitle(e.target.value)} aria-label="Название новой записи" /></Field>
        {fields.map((f) => (
          <Field key={f.id} label={<>{f.name} *</>}>
            {f.fieldType === 'date' ? <DateInput value={values[f.key] ?? ''} aria-label={f.name} onChange={(v) => setValues({ ...values, [f.key]: v })} />
              : <Input type={f.fieldType === 'number' || f.fieldType === 'money' ? 'number' : f.fieldType === 'url' ? 'url' : 'text'} value={values[f.key] ?? ''}
                placeholder={f.fieldType === 'url' ? 'https://…' : undefined} aria-label={f.name} onChange={(e) => setValues({ ...values, [f.key]: e.target.value })} />}
          </Field>
        ))}
        <div className={s.dialogFoot}><Button type="button" onClick={onClose}>Отмена</Button><Button type="submit" variant="primary" disabled={!!missing}>Создать</Button></div>
      </form>
    </Dialog>
  );
}
